import React from "react";
import { ArrowLeft, Home, RefreshCcw } from "lucide-react";
import { PageShell, PageHero, PageSection } from "../components/PageShell";
import { Button } from "../components/ui/button";

export default function ErrorPage() {
  return (
    <PageShell>
      <PageHero
        eyebrow="Oops"
        title="Page not found."
        highlight="Try again."
        description="The page you’re looking for doesn’t exist or you don’t have access."
      />

      <PageSection variant="content">
        <div className="mx-auto max-w-4xl rounded-3xl bg-card border border-border p-8 shadow-soft">
          <div className="grid sm:grid-cols-3 gap-3">
            <Button size="lg" onClick={() => (window.location.href = "/")}>
                <Home className="h-4 w-4 mr-2" />
                Home
            </Button>
            <Button
              variant="outline"
              size="lg"
              onClick={() => (window.location.href = "/dashboard")}
            >
                <ArrowLeft className="h-4 w-4 mr-2" />
                Dashboard
            </Button>
            <Button
              variant="outline"
              size="lg"
              onClick={() => window.location.reload()}
            >
              <RefreshCcw className="h-4 w-4 mr-2" />
              Reload
            </Button>
          </div>
        </div>
      </PageSection>
    </PageShell>
  );
}

